import { SiteModel } from "../../models/Site";
import { IQuerySiteRepository } from "../../ports/sites/IQuerySiteRepository";
import Query from "../Query";

class SiteQuery extends Query<SiteModel> implements IQuerySiteRepository {}

export default SiteQuery;
